// Datasets / connectors needing human attention (failed syncs, stale).
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { AlertTriangle, Clock3, ArrowUpRight } from "lucide-react";

const KIND_META = {
    connector_failed: { color: "text-rose-500", icon: AlertTriangle, label: "FAILED" },
    connector_stale:  { color: "text-amber-500", icon: Clock3,        label: "STALE"  },
};

function timeAgo(iso) {
    if (!iso) return "—";
    const diff = (Date.now() - new Date(iso).getTime()) / 1000;
    if (diff < 3600) return `${Math.round(diff / 60)}m`;
    if (diff < 86400) return `${Math.round(diff / 3600)}h`;
    return `${Math.round(diff / 86400)}d`;
}

export default function DatasetsAttentionWidget() {
    const [items, setItems] = useState(null);
    const navigate = useNavigate();
    useEffect(() => {
        api.get("/home/widget/datasets-attention")
           .then((r) => setItems(r.data || [])).catch(() => setItems([]));
    }, []);
    return (
        <div className="border border-border rounded-sm bg-card p-4 h-full" data-testid="home-widget-datasets-attention">
            <div className="flex items-center justify-between mb-3">
                <div className="flex items-center gap-1.5">
                    <AlertTriangle className="h-3.5 w-3.5 text-amber-500" strokeWidth={2} />
                    <span className="eyebrow text-[10px]">Needs attention</span>
                </div>
                <button onClick={() => navigate("/data?tab=connectors")}
                        className="text-[10px] font-mono uppercase tracking-wider text-muted-foreground hover:text-primary"
                        data-testid="home-attention-all">
                    All sources →
                </button>
            </div>
            {items === null && <div className="text-xs text-muted-foreground">Loading…</div>}
            {items && items.length === 0 && (
                <div className="text-[12px] text-muted-foreground py-6 text-center">
                    All clean — no failed or stale sources.
                </div>
            )}
            {items && items.length > 0 && (
                <ul className="space-y-1.5 max-h-[260px] overflow-y-auto scrollbar-thin pr-1">
                    {items.map((it, i) => {
                        const meta = KIND_META[it.kind] || KIND_META.connector_stale;
                        const Icon = meta.icon;
                        return (
                            <li key={i}>
                                <button onClick={() => navigate(`/data?tab=connectors&connector=${it.id}`)}
                                    className="w-full group flex items-center gap-2.5 p-2 hover:bg-secondary/40 rounded-sm text-left"
                                    data-testid={`home-attention-${i}`}>
                                    <Icon className={`h-3.5 w-3.5 ${meta.color} shrink-0`} strokeWidth={2} />
                                    <div className="flex-1 min-w-0">
                                        <div className="text-sm truncate">{it.name}</div>
                                        <div className="text-[10px] font-mono uppercase tracking-wider text-muted-foreground">
                                            <span className={meta.color}>{meta.label}</span>
                                            <span> · {it.detail}</span>
                                            {it.ts && <span> · {timeAgo(it.ts)} ago</span>}
                                        </div>
                                    </div>
                                    <ArrowUpRight className="h-3.5 w-3.5 text-muted-foreground opacity-0 group-hover:opacity-100" />
                                </button>
                            </li>
                        );
                    })}
                </ul>
            )}
        </div>
    );
}
